export const mapDetalleToLine = (detalle) => ({
  id: detalle.id || Date.now(),
  referencia: detalle.producto?.codigo || detalle.codigo || detalle.referencia || "",
  nombre:
    detalle.producto?.descripcion ||
    detalle.glosa ||
    detalle.nombre ||
    detalle.descripcion ||
    "",
  descripcion:
    detalle.producto?.descripcion ||
    detalle.glosa ||
    detalle.descripcion ||
    detalle.nombre ||
    "",
  um: detalle.unidad || detalle.um || detalle.producto?.unidad || "",
  stock: detalle.stock ?? 0,
  centro:
    detalle.almacen?.almacen ||
    detalle.almacen?.codigo ||
    detalle.almacen ||
    detalle.centro ||
    "",
  precio_lista:
    detalle.precioLista ??
    detalle.precio_lista ??
    detalle.valorUnitario ??
    detalle.valor_unitario ??
    detalle.precio ??
    0,
  precio:
    detalle.precio ??
    detalle.valorUnitario ??
    detalle.valor_unitario ??
    detalle.precioLista ??
    detalle.precio_lista ??
    0,
  cantidad: detalle.cantidad ?? 1,
  descuento: detalle.descuento ?? 0,
  total: detalle.total ?? 0,
  flete: detalle.flete,
  calzada: detalle.calzada ?? 0,
  cajaCompleta: detalle.cajaCompleta ?? detalle.caja_completa ?? false,
});
